export default __webpack_public_path__ + "static/msfMap-bf0629933b9fa361cb68ba1838f38f2a.png";